import { DEFAULT_LAYOUT } from '@/router/constant'
import type { RouteRecordRaw } from 'vue-router'

const product: RouteRecordRaw = {
  path: '/product',
  name: 'Product',
  component: DEFAULT_LAYOUT,
  redirect: '/product/list',

  children: [
    {
      path: 'list',
      name: 'ProductList',
      component: () =>
        import(/** webpackChunkName "initialize" */ '@/views/product/ProductList.vue'),
      meta: { title: '商品一覧画面', requiresAuth: true },
    },

    {
      path: 'details',
      name: 'ProductDetails',
      component: () =>
        import(/** webpackChunkName "initialize" */ '@/views/product/ProductDetails.vue'),
      meta: { title: '商品詳細画面', requiresAuth: true },
    },

    {
      path: 'add',
      name: 'ProductAdd',
      component: () =>
        import(/** webpackChunkName "initialize" */ '@/views/product/ProductAdd.vue'),
      meta: { title: '商品登録画面', requiresAuth: true },
    },

    {
      path: 'document-detail',
      name: 'DocumentDetail',
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/product/DocumentDetail/MainPage.vue'
        ),
      props: true,
      meta: { title: 'ドキュメント詳細画面', requiresAuth: true },
    },

    {
      path: 'bulk-revision-send-list',
      name: 'BulkRevisionSendList',
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/product/BulkRevisionSendList/BulkRevisionSendList.vue'
        ),
      props: true,
      meta: { title: '一括改版送信の選択', requiresAuth: true },
    },

    {
      path: 'bulk-revision-send-edit',
      name: 'BulkRevisionSendEdit',
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/product/BulkRevisionSendEdit/BulkRevisionSendEdit.vue'
        ),
      props: true,
      meta: { title: '一括改版送信の編集', requiresAuth: true },
    },
    {
      path: 'bulk-revision-send-edit-confirm',
      name: 'BulkRevisionSendEditConfirm',
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/product/BulkRevisionSendEditConfirm/BulkRevisionSendEditConfirm.vue'
        ),
      props: true,
      meta: { title: '送信内容の確認', requiresAuth: true },
    },
  ],
}

export default product
